export const numberSpliter = val => {
  let result = val;
  result += "";
  result = result.replace(",", "");
  let splitNumber = result.split(".");
  let integerNumber = splitNumber[0];
  let decimalNumber = splitNumber.length > 1 ? "." + splitNumber[1] : "";
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(integerNumber)) {
    integerNumber = integerNumber.replace(rgx, "$1" + "," + "$2");
  }

  return integerNumber + decimalNumber;
};
export const sleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
export const timerMinScound = time => {
  let min = parseInt(time / 60);
  min = min < 10 ? "0" + min : min;
  let secound = parseInt(time % 60);
  secound = secound < 10 ? "0" + secound : secound;
  return min + " : " + secound;
};
